const SiteFooter = () => {

    return (
        <footer className="text-center bg-white text-muted border-top mt-auto py-3">
            { /* Section for social media */}
            <div className="container">

                <div className="row border-bottom p-2">
                    <div className="col-12 col-md-6 text-end">
                        <p className="mb-0">Get connected with us on social networks:</p>
                    </div>
                    <div className="col-12 col-md-6 text-start">
                        <a href="http://www.facebook.com/home.php#!/pages/Academy-of-European-Law-ERA/139678109402356" className="me-4 text-reset">
                            <i className="bi bi-facebook"></i>
                        </a>
                        <a href="http://twitter.com/#!/ERATrier" className="me-4 text-reset">
                            <i className="bi bi-twitter"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UCg854EMdaxEgKj0h7026BVA" className="me-4 text-reset">
                            <i className="bi bi-youtube"></i>
                        </a>
                        <a href="https://www.linkedin.com/company-beta/521683/" className="me-4 text-reset">
                            <i className="bi bi-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div className="row p-2">
                    <div className="col-12 text-center">
                        <p className="mb-0"><b>Academy of European Law</b> - Metzer Allee 4, 54295 Trier - Germany, +49 (0)651 937737-0, info(at)era.int</p>
                    </div>
                </div>

            </div>
        </footer>
    )

}
export default SiteFooter;